import { render, staticRenderFns } from "./DirectAvailabilitySection.vue?vue&type=template&id=2e495aa4&scoped=true&"
import script from "./DirectAvailabilitySection.vue?vue&type=script&lang=js&"
export * from "./DirectAvailabilitySection.vue?vue&type=script&lang=js&"
import style0 from "./DirectAvailabilitySection.vue?vue&type=style&index=0&id=2e495aa4&prod&lang=css&"
import style1 from "./DirectAvailabilitySection.vue?vue&type=style&index=1&id=2e495aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e495aa4",
  null
  
)

export default component.exports